// Native <details> keeps navigation operable without JavaScript.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openMenu = document.querySelector('.rh-mobile-menu[open]');
  if (openMenu) {
    openMenu.removeAttribute('open');
    openMenu.querySelector('summary')?.focus();
  }
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.rh-mobile-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  });
});

